exports.getOneIndivDemande = async (id) => {
  const res = await axios.get(`/demande-indiv/${id}`);

  if (res && res.data && res.data.success) {
      return res.data.data;
  } else return null;
};
